import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import fontawesome from './services/fontawesome';

import { Head, Link } from '@inertiajs/inertia-vue3'

fontawesome();

const core = {
  install(Vue, options) {
    Vue.component('Head', Head)
    Vue.component('Link', Link)
    Vue.component('Icon', FontAwesomeIcon)
  }
}

export { core }